/* Compact controls shared by all free-design and birth configurators. */
(()=>{
 const init=()=>{
  const roots=document.querySelectorAll('[data-bb-designer],[data-birth-proposal],.bb-product:has([data-bb-name])');
  if(!roots.length)return;
  document.documentElement.dataset.bbUi='compact';
  for(const root of roots){
   const birth=root.matches('[data-birth-proposal]');
   const preset=!birth&&!root.matches('[data-bb-designer]');
   const controls=birth?root.querySelector('[data-birth-step="2"]'):root.querySelector(preset?'[data-name-step="2"]':'[data-text-controls]');
   if(!controls||controls.querySelector('.bb-compact-advanced'))continue;
   const fontControl=controls.querySelector(birth?'[data-birth-font]':preset?'[data-bb-font]':'[data-font]');
   const font=fontControl?.closest(preset?'.bb-name-options>div':'label');
   const colors=birth?controls.querySelector('[data-birth-color]')?.closest('fieldset'):preset?controls.querySelector('[data-bb-color]')?.closest('.bb-name-options>div'):controls.querySelector('.bb-designer-text-colors');
   if(!font&&!colors)continue;
   const advanced=document.createElement('details');advanced.className='bb-compact-advanced';
   const summary=document.createElement('summary');summary.textContent='Lettertype en tekstkleur';advanced.append(summary);
   if(font)advanced.append(font);if(colors)advanced.append(colors);controls.append(advanced);
  }
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
